<template>
  <div class="page flex-col">
    <div class="group_1 flex-col">
      <div class="block_1 flex-row">
        <img class="image_1" referrerpolicy="no-referrer" src="../../assets/img/head_logo.png" />
        <div class="nav-item" @click="goHome()">
          <span class="nav-text">首页</span>
          <span class="nav-line"></span>
        </div>
        <div class="nav-item" @click="goProduct()">
          <span class="nav-text">产品中心</span>
          <span class="nav-line"></span>
        </div>
        <div class="nav-item" @click="goService()">
          <span class="nav-text">服务中心</span>
          <span class="nav-line"></span>
        </div>
        <div class="nav-item active">
          <span class="nav-text">关于我们</span>
          <span class="nav-line"></span>
        </div>
        <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/head_phone.png" />
        <div class="text-wrapper_1">
          <span class="text_5">联系我们：</span>
          <span class="text_6">4000506688</span>
        </div>
      </div>
      <div class="section_4 flex-col">
        <div class="group_2 flex-col">
          <div class="box_3 flex-col"></div>
        </div>
        <div class="text-wrapper_1 flex-col"><span class="text_1">深耕眼视光领域&nbsp;·&nbsp;专注眼健康未来</span></div>
        <div class="group_3 flex-row">
          <div class="section_1 flex-col">
            <div class="text-wrapper_2">
              <div class="text_1"><span
                  class="text_2">天津新视光技术有限公司</span>成立于2019年,乐普医疗（股票代码：300003）旗下子公司，是智能视觉健康服务解决方案服务商。依托物联网、人工智能及云服务技术,<span
                  class="text_2">致力于视功能诊疗产品的研发与生产</span>。</div>
              <div class="text_1">
                <span class="text_2">以【优眼】系列为核心</span>,为医疗机构、视光中心及个人提供从<span class="text_2">视功能检查</span>到<span
                  class="text_2">视觉训练</span>的一站式智能化解决方案,通过自动化检查流程与标准化数据管理,助力功能性眼病的规范化诊疗。
              </div>
            </div>
          </div>
          <div class="group_6 flex-col">
            <div class="list_4 flex-row">
              <div class="image-text_4 flex-col justify-between" v-for="(item, index) in loopData0" :key="index">
                <img class="label_1" referrerpolicy="no-referrer" :src="item.lanhuimage0" />
                <span class="text-group_1" v-html="item.lanhutext0"></span>
                <div class="text-wrapper_16">
                  <span class="text_11">{{ item.num }}</span>
                  <span class="text_12">项</span>
                </div>
              </div>
            </div>
            <!-- <div class="text-wrapper_16 flex-row">
              <span class="text_11">3</span>
              <span class="text_12">项</span>
              <span class="text_13">6</span>
              <span class="text_14">项</span>
              <span class="text_15">8</span>
              <span class="text_16">项</span>
              <span class="text_17">16</span>
              <span class="text_18">项</span>
            </div> -->
            <img class="image_1" referrerpolicy="no-referrer" src="./assets/img/40f052a89b2538e16c8d2c0a4b87d40a.png" />
          </div>
        </div>
        <div class="group_4 flex-col">
          <div class="box_6 flex-row justify-between">
            <div class="text-wrapper_4 flex-col"><span class="text_19">30+</span></div>
            <div class="text-wrapper_5 flex-col"><span class="text_20">800+</span></div>
            <div class="text-wrapper_6 flex-col"><span class="text_21">1100+</span></div>
            <div class="text-wrapper_7 flex-col"><span class="text_22">100W+</span></div>
          </div>
          <div class="text-wrapper_17 flex-row justify-between">
            <span class="text_23">服务地区</span>
            <span class="text_24">合作医院</span>
            <span class="text_25">合作机构</span>
            <span class="text_26">服务人次</span>
          </div>
          <div class="text-wrapper_18 flex-row">
            <span class="text_27">数据截至2025年11月，来源于公司内部统计</span>
          </div>
        </div>
        <div class="group_5 flex-col">
          <img class="image_1" referrerpolicy="no-referrer"
            src="https://lanhu-oss-proxy.lanhuapp.com/06275da8fe2ec5eb15acbc4d8926a176" />
        </div>
      </div>
      <div class="bottom_box flex-row">
        <img class="image_11" referrerpolicy="no-referrer" src="../../assets/img/bottom_phone.png" />
        <div class="text-wrapper_20 flex-col justify-between">
          <span class="text_40">联系我们：</span>
          <span class="text_41">400&nbsp;050&nbsp;6688</span>
          <div class="network-keycord">津ICP备2021007957号-1</div>
        </div>
        <div class="image-text_11 flex-col justify-between">
          <img class="image_12" referrerpolicy="no-referrer" src="../../assets/img/bottom_ercode1.png" />
          <span class="text-group_5">视频号</span>
        </div>
        <div class="image-text_12 flex-col justify-between">
          <img class="image_13" referrerpolicy="no-referrer" src="../../assets/img/bottom_ercode2.png" />
          <span class="text-group_6">公众号</span>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loopData0: [
        {
          lanhuimage0: 'https://lanhu-oss-proxy.lanhuapp.com/551f7101e23aeb2f834e47cab3d593a6',
          lanhutext0: '发明专利',
          num: 3
        },
        {
          lanhuimage0: 'https://lanhu-oss-proxy.lanhuapp.com/05ad5cbfbbee40feb754fc4ca5396d58',
          lanhutext0: '实用新型专利',
          num: 6
        },
        {
          lanhuimage0: 'https://lanhu-oss-proxy.lanhuapp.com/089ede3e3a52c2e9ac9da7043b26c95c',
          lanhutext0: '外观专利',
          num: 8
        },
        {
          lanhuimage0: 'https://lanhu-oss-proxy.lanhuapp.com/62d6550a995bd8cf1df56ce87b72e0c4',
          lanhutext0: '软件著作权',
          num: 16
        }
      ],
      constants: {}
    };
  },
  mounted() {
    this.injectStructuredData();
  },
  beforeDestroy() {
    this.removeStructuredData();
  },
  methods: {
    // 注入结构化数据供 AI 爬虫抓取
    injectStructuredData() {
      // 面包屑导航
      const breadcrumbData = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "首页",
            "item": "https://test.uyu.com/uyu_home"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "关于我们",
            "item": "https://test.uyu.com/uyu_about"
          }
        ]
      };

      // 组织详细信息
      const organizationData = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "天津新视光技术有限公司",
        "alternateName": "优眼智家",
        "url": "https://test.uyu.com",
        "logo": "https://test.uyu.com/favicon.ico",
        "description": "成立于2019年，乐普医疗（股票代码：300003）旗下子公司，是智能视觉健康服务解决方案服务商。依托物联网、人工智能及云服务技术，致力于视功能诊疗产品的研发与生产。以【优眼】系列为核心，为医疗机构、视光中心及个人提供从视功能检查到视觉训练的一站式智能化解决方案。",
        "foundingDate": "2019",
        "telephone": "400-050-6688",
        "address": {
          "@type": "PostalAddress",
          "addressCountry": "CN",
          "addressLocality": "天津"
        },
        "parentOrganization": {
          "@type": "Organization",
          "name": "乐普医疗",
          "tickerSymbol": "300003"
        },
        "numberOfEmployees": {
          "@type": "QuantitativeValue",
          "description": "专业团队规模"
        },
        "areaServed": {
          "@type": "Country",
          "name": "中国"
        },
        "sameAs": []
      };

      // 关于我们页面信息
      const aboutPageData = {
        "@context": "https://schema.org",
        "@type": "AboutPage",
        "name": "关于优眼智家",
        "url": "https://test.uyu.com/uyu_about",
        "description": "深耕眼视光领域，专注眼健康未来。天津新视光技术有限公司成立于2019年，乐普医疗旗下子公司，智能视觉健康服务解决方案服务商。",
        "isPartOf": {
          "@type": "WebSite",
          "name": "优眼智家官网",
          "url": "https://test.uyu.com"
        },
        "mainEntity": organizationData
      };

      // 知识产权数据
      const patentData = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        "name": "优眼智家知识产权",
        "description": "优眼智家拥有的知识产权成果",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "发明专利",
            "description": "3项发明专利"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "实用新型专利",
            "description": "6项实用新型专利"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "外观专利",
            "description": "8项外观专利"
          },
          {
            "@type": "ListItem",
            "position": 4,
            "name": "软件著作权",
            "description": "16项软件著作权"
          }
        ]
      };

      // 服务统计数据
      const statisticsData = {
        "@context": "https://schema.org",
        "@type": "Dataset",
        "name": "优眼智家服务统计数据",
        "description": "优眼智家截至2025年11月的服务统计数据",
        "distribution": {
          "@type": "DataDownload",
          "name": "服务统计",
          "contentUrl": "https://test.uyu.com/uyu_about"
        },
        "variablesMeasured": [
          { "@type": "PropertyValue", "name": "服务地区数量", "value": "30+" },
          { "@type": "PropertyValue", "name": "合作医院数量", "value": "800+" },
          { "@type": "PropertyValue", "name": "合作机构数量", "value": "1100+" },
          { "@type": "PropertyValue", "name": "服务人次", "value": "100万+" }
        ]
      };

      // 注入到页面
      const dataList = [
        { id: 'breadcrumb', data: breadcrumbData },
        { id: 'organization', data: organizationData },
        { id: 'aboutpage', data: aboutPageData },
        { id: 'patent', data: patentData },
        { id: 'statistics', data: statisticsData }
      ];

      dataList.forEach(item => {
        const script = document.createElement('script');
        script.id = `structured-data-about-${item.id}`;
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify(item.data);
        document.head.appendChild(script);
      });
    },
    removeStructuredData() {
      const ids = ['breadcrumb', 'organization', 'aboutpage', 'patent', 'statistics'];
      ids.forEach(id => {
        const script = document.getElementById(`structured-data-about-${id}`);
        if (script) document.head.removeChild(script);
      });
    },
    goHome() {
      this.$router.push('/uyu_home')
    },
    goProduct() {
      this.$router.push('/uyu_product');
    },
    goService() {
      this.$router.push('/uyu_service');
    }
  }
};
</script>
<style scoped lang="less" src="./assets/index.response.less" />